import { FormCard, FormItem, Input } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'

export const NameFormCard = () => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  return (
    <FormCard title={t(supConstants.NAME)}>
      <FormItem
        label={<Text>{t(supConstants.PREFERRED_NAME)}</Text>}
        name="preferredName"
        rules={[
          {
            max: 70,
            message: t(supConstants.PREFERRED_NAME_MAX_LENGTH)
          }
        ]}
      >
        <Input maxLength={70} />
      </FormItem>
      <FormItem
        label={<Text>{t(supConstants.FIRST_NAME)}</Text>}
        name={['name', 'first']}
        rules={[
          {
            required: true,
            message: `${t(supConstants.PLEASE_ENTER)} ${t(
              supConstants.FIRST_NAME
            )}`
          },
          {
            max: 35,
            message: t(supConstants.FIRST_NAME_MAX_LENGTH)
          }
        ]}
      >
        <Input maxLength={35} />
      </FormItem>
      <FormItem
        label={<Text>{t(supConstants.LAST_NAME)}</Text>}
        name={['name', 'last']}
        rules={[
          {
            required: true,
            message: `${t(supConstants.PLEASE_ENTER)} ${t(
              supConstants.LAST_NAME
            )}`
          },
          {
            max: 35,
            message: t(supConstants.LAST_NAME_MAX_LENGTH)
          }
        ]}
      >
        <Input maxLength={35} />
      </FormItem>
    </FormCard>
  )
}
